import React from 'react';
import PropTypes from 'prop-types';
import EditPDFLandingPageFullWidthUploadPanel from './EditPDFLandingPageFullWidthUploadPanel';
import EditPDFLandingPageBenefitsSection from './EditPDFLandingPageBenefitsSection';

const EditPDFLandingPageFullWidthUploadPanelLayout = props => (
  <div className="indexRedesign large-upload-panel-wrapper">
    <div className="container-fluid">
      <div className="row-fluid">
        <div className="span12 editor-landing">
          <div className="large-upload-panel-info-wrapper">
            <h1 className="large-upload-panel-page-header">Free PDF Editor</h1>
            <h2 className="large-upload-panel-page-sub-header">
              No software required. Simply upload and go!
            </h2>
          </div>
        </div>
        <EditPDFLandingPageFullWidthUploadPanel
          ctaId={props.ctaId}
        />
      </div>
      <EditPDFLandingPageBenefitsSection isFullWidthUploadPanel />
    </div>
  </div>
);

EditPDFLandingPageFullWidthUploadPanelLayout.propTypes = {
  ctaId: PropTypes.string.isRequired,
};

export default EditPDFLandingPageFullWidthUploadPanelLayout;



// WEBPACK FOOTER //
// ./src-react/EditPDFLandingPage/EditPDFLandingPageFullWidthUploadPanelLayout.jsx